import { TransferNotification } from '#/api/ws/ws';

export function depositToastView(transfer: TransferNotification['data']) {
  return {
    id: transfer.id,
    amount: `${transfer.amount.toFormat(2)} ${transfer.token}`,
  };
}

export function withdrawalToastView(transfer: TransferNotification['data']) {
  return {
    id: transfer.id,
    amount: `${transfer.amount.toFormat(2)} ${transfer.token}`,
  };
}
